import React from "react";
import "./CourseCard.css";
const CourseCard = (props) => {
  const { classN, Age, img, addmisionFee, courseDuration, monthlyFee } =
    props.mainCourse || {};
  return (
    <div className="col">
      <div className="card h-80 p-2 m-3">
        <img src={img} height="250px" className="card-img-top" alt={classN} />
        <div className="card-body">
          <h5 className="card-title">Class Name: {classN}</h5>
          <p className="card-text">Age: {Age}</p>
          <p className="card-text">Addmision Fee: {addmisionFee}</p>
          <p className="card-text">Monthly Fee: {monthlyFee}</p>
          <p className="card-text">Course Duration: {courseDuration}</p>
          <button type="button" className="btn btn-success">
            Addmision Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
